import script from "./PDFLabels.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFLabels.vue?vue&type=script&setup=true&lang=js"

import "./PDFLabels.vue?vue&type=style&index=0&id=e02299c6&lang=css"

const __exports__ = script;

export default __exports__